(function(e, a) { for(var i in a) e[i] = a[i]; }(exports, /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/@types/index.ts":
/*!*****************************!*\
  !*** ./src/@types/index.ts ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Autorename = exports.Source = exports.Mode = void 0;
var Mode;
(function (Mode) {
    Mode["combined"] = "combined";
    Mode["override"] = "override";
})(Mode = exports.Mode || (exports.Mode = {}));
var Source;
(function (Source) {
    Source["ltr"] = "ltr";
    Source["rtl"] = "rtl";
})(Source = exports.Source || (exports.Source = {}));
var Autorename;
(function (Autorename) {
    Autorename["disabled"] = "disabled";
    Autorename["flexible"] = "flexible";
    Autorename["strict"] = "strict";
})(Autorename = exports.Autorename || (exports.Autorename = {}));


/***/ }),

/***/ "./src/index.ts":
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var rtl_react_1 = __webpack_require__(/*! ./rtl-react */ "./src/rtl-react/index.ts");
Object.defineProperty(exports, "reactRTLJsInit", { enumerable: true, get: function () { return rtl_react_1.reactRTLJsInit; } });
Object.defineProperty(exports, "reactPropsProcessor", { enumerable: true, get: function () { return rtl_react_1.reactPropsProcessor; } });
Object.defineProperty(exports, "processor", { enumerable: true, get: function () { return rtl_react_1.processor; } });
Object.defineProperty(exports, "processorForNew", { enumerable: true, get: function () { return rtl_react_1.processorForNew; } });
Object.defineProperty(exports, "rtlCssReact", { enumerable: true, get: function () { return rtl_react_1.rtlCssReact; } });
Object.defineProperty(exports, "RTLSkipStart", { enumerable: true, get: function () { return rtl_react_1.RTLSkipStart; } });
Object.defineProperty(exports, "RTLSkipEnd", { enumerable: true, get: function () { return rtl_react_1.RTLSkipEnd; } });
var index_1 = __webpack_require__(/*! @utilities/index */ "./src/utilities/index.ts");
Object.defineProperty(exports, "setRTLStatus", { enumerable: true, get: function () { return index_1.setRTLStatus; } });
var _types_1 = __webpack_require__(/*! ./@types */ "./src/@types/index.ts");
Object.defineProperty(exports, "Mode", { enumerable: true, get: function () { return _types_1.Mode; } });
Object.defineProperty(exports, "Source", { enumerable: true, get: function () { return _types_1.Source; } });
Object.defineProperty(exports, "Autorename", { enumerable: true, get: function () { return _types_1.Autorename; } });


/***/ }),

/***/ "./src/rtl-react/index.ts":
/*!********************************!*\
  !*** ./src/rtl-react/index.ts ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reactRTLJsInit = exports.processorForNew = exports.processor = exports.reactChildrenProcessor = exports.reactPropsProcessor = void 0;
var plugins_1 = __webpack_require__(/*! ./plugins */ "./src/rtl-react/plugins.ts");
var index_1 = __webpack_require__(/*! @utilities/index */ "./src/utilities/index.ts");
var plugins_2 = __webpack_require__(/*! ./plugins */ "./src/rtl-react/plugins.ts");
Object.defineProperty(exports, "rtlCssReact", { enumerable: true, get: function () { return plugins_2.rtlCssReact; } });
__exportStar(__webpack_require__(/*! ./skip */ "./src/rtl-react/skip.ts"), exports);
exports.reactPropsProcessor = function (props) {
    var children = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        children[_i - 1] = arguments[_i];
    }
    if (!index_1.isRTL)
        return props;
    if (index_1.skipCSSProcess && (props === null || props === void 0 ? void 0 : props.className)) {
        index_1.addDisabledClassName(props.className);
        return props;
    }
    if ((props === null || props === void 0 ? void 0 : props.className) && index_1.isDisabledClassName(props === null || props === void 0 ? void 0 : props.className))
        return props;
    return plugins_1.propsPluginList.reduce(function (pre, cur) {
        return cur.apply(void 0, __spreadArrays([pre], children));
    }, props);
};
exports.reactChildrenProcessor = function () {
    var children = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        children[_i] = arguments[_i];
    }
    if (!index_1.isRTL)
        return children;
    return plugins_1.childrenPluginList.reduce(function (pre, cur) {
        return cur.apply(void 0, pre);
    }, children);
};
exports.processor = function (props) {
    var children = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        children[_i - 1] = arguments[_i];
    }
    if (!index_1.isRTL)
        return __spreadArrays([props], children);
    var newProps = exports.reactPropsProcessor.apply(void 0, __spreadArrays([props], children));
    return __spreadArrays([newProps], children);
};
exports.processorForNew = function (props) {
    var children = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        children[_i - 1] = arguments[_i];
    }
    if (!index_1.isRTL)
        return props;
    var newProps = exports.reactPropsProcessor.apply(void 0, __spreadArrays([props], children));
    return newProps;
};
exports.reactRTLJsInit = function (react, option) {
    index_1.initRuntimeOption(option, react);
    var createElement = react.createElement;
    var newCreateElement = (function (type, props) {
        var children = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            children[_i - 2] = arguments[_i];
        }
        var _a = exports.processor.apply(void 0, __spreadArrays([props], children)), newProps = _a[0], newChildren = _a.slice(1);
        return createElement.apply(void 0, __spreadArrays([type, newProps], newChildren));
    });
    react.createElement = newCreateElement;
};


/***/ }),

/***/ "./src/rtl-react/plugins.ts":
/*!**********************************!*\
  !*** ./src/rtl-react/plugins.ts ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.childrenPluginList = exports.propsPluginList = exports.processPercentPlugin = exports.processIsRTLPropPlugin = exports.processCssPlugin = exports.rtlCssReact = void 0;
var config_1 = __webpack_require__(/*! @utilities/config */ "./src/utilities/config.ts");
var index_1 = __webpack_require__(/*! @utilities/index */ "./src/utilities/index.ts");
exports.rtlCssReact = function (css) {
    var newCss = {};
    var cssPropList = Object.keys(css);
    for (var _i = 0, cssPropList_1 = cssPropList; _i < cssPropList_1.length; _i++) {
        var cssProp = cssPropList_1[_i];
        var cssValue = css[cssProp];
        var processedCss = config_1.process(cssProp, cssValue);
        newCss[processedCss.prop] = processedCss.value;
    }
    return newCss;
};
exports.processCssPlugin = function (props) {
    if (!(props === null || props === void 0 ? void 0 : props.style))
        return props;
    if (!index_1.isObject(props.style))
        return props;
    if (props === null || props === void 0 ? void 0 : props['data-rtl-disabled'])
        return props;
    return __assign(__assign({}, props), { style: exports.rtlCssReact(props.style) });
};
exports.processIsRTLPropPlugin = function (props) {
    if (!(props === null || props === void 0 ? void 0 : props['data-rtl']))
        return props;
    var css = props.style || {};
    var transform = css.transform || '';
    var hadScale = transform.includes(config_1.scaleCss);
    var newCss = __assign(__assign({}, css), { transform: hadScale ? transform : transform + " " + config_1.scaleCss });
    return __assign(__assign({}, props), { style: newCss });
};
var ignoreTypes = ['object', 'function', 'symbol'];
exports.processPercentPlugin = function () {
    var children = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        children[_i] = arguments[_i];
    }
    if (index_1.isBlank(children === null || children === void 0 ? void 0 : children[0]))
        return children;
    var newChildren = [];
    if (!/([\d.,]*\d)(%)/g.test(children.join('')))
        return children;
    var skip = false;
    for (var i = 0, len = children.length; i < len; i++) {
        var childrenType = typeof children[i];
        if (ignoreTypes.includes(childrenType)) {
            newChildren.push(children[i]);
            continue;
        }
        if (skip) {
            skip = false;
            continue;
        }
        var curChild = "" + children[i];
        var nextChild = "" + children[i + 1];
        var curIsMatch = /([\d.,]*\d)(%)/g.test(curChild);
        var nextIsMatch = /([\d.,]*\d)(%)/g.test(nextChild);
        if (curIsMatch) {
            newChildren.push(curChild.replace(/([\d.,]*\d)(%)/g, function (str, num, sign) {
                return "" + sign + num;
            }));
            continue;
        }
        if (!curIsMatch && !nextIsMatch && /([\d.,]*\d)(%)/g.test("" + curChild + nextChild)) {
            newChildren.push(("" + curChild + nextChild).replace(/([\d.,]*\d)(%)/g, function (str, num, sign) {
                return "" + sign + num;
            }));
            skip = true;
            continue;
        }
        newChildren.push(curChild);
    }
    return newChildren;
};
exports.propsPluginList = [
    exports.processCssPlugin,
    exports.processIsRTLPropPlugin,
];
exports.childrenPluginList = [
    exports.processPercentPlugin
];


/***/ }),

/***/ "./src/rtl-react/skip.ts":
/*!*******************************!*\
  !*** ./src/rtl-react/skip.ts ***!
  \*******************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTLSkipEnd = exports.RTLSkipStart = void 0;
var react_1 = __importDefault(__webpack_require__(/*! react */ "react"));
var index_1 = __webpack_require__(/*! @utilities/index */ "./src/utilities/index.ts");
exports.RTLSkipStart = function () {
    index_1.setSkipStatus(true);
    return react_1.default.createElement(react_1.default.Fragment, null);
};
exports.RTLSkipEnd = function () {
    index_1.setSkipStatus(false);
    return react_1.default.createElement(react_1.default.Fragment, null);
};


/***/ }),

/***/ "./src/utilities/config.ts":
/*!*********************************!*\
  !*** ./src/utilities/config.ts ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.scaleCss = exports.process = exports.processorList = void 0;
var index_1 = __importStar(__webpack_require__(/*! @utilities/index */ "./src/utilities/index.ts"));
exports.processorList = [
    {
        name: 'variable',
        expr: /^--/im,
        action: function (prop, value) {
            return { prop: prop, value: value };
        },
    },
    {
        name: 'direction',
        expr: /direction/im,
        action: function (prop, value) {
            return { prop: prop, value: index_1.default.swapLtrRtl(value) };
        },
    },
    {
        name: 'left',
        expr: /left/im,
        action: function (prop, value) {
            return {
                prop: prop.replace(this.expr, function () {
                    if (prop.includes('-left') || prop === 'left') {
                        return 'right';
                    }
                    return 'Right';
                }),
                value: value,
            };
        },
    },
    {
        name: 'right',
        expr: /right/im,
        action: function (prop, value) {
            return {
                prop: prop.replace(this.expr, function () {
                    if (prop.includes('-right') || prop === 'right') {
                        return 'left';
                    }
                    return 'Left';
                }),
                value: value,
            };
        },
    },
    {
        name: 'four-value syntax',
        expr: /^(margin|padding|border-(color|style|width))$/gi,
        cache: null,
        action: function (prop, value) {
            if (this.cache === null) {
                this.cache = {
                    match: /[^\s\uFFFD]+/g,
                };
            }
            var state = index_1.default.guardFunctions(value);
            if (typeof value === 'number') {
                return { prop: prop, value: index_1.default.unguardFunctions(state) };
            }
            var result = state.value.match(this.cache.match);
            if (result &&
                result.length === 4 &&
                (state.store.length > 0 || result[1] !== result[3])) {
                var i_1 = 0;
                state.value = state.value.replace(this.cache.match, function () {
                    return result[(4 - i_1++) % 4];
                });
            }
            return { prop: prop, value: index_1.default.unguardFunctions(state) };
        },
    },
    {
        name: 'border radius',
        expr: /border-radius/gi,
        cache: null,
        flip: function (value) {
            var parts = value.match(this.cache.match);
            var i;
            if (parts) {
                switch (parts.length) {
                    case 2:
                        i = 1;
                        if (parts[0] !== parts[1]) {
                            value = value.replace(this.cache.match, function () {
                                return parts[i--];
                            });
                        }
                        break;
                    case 3:
                        value = value.replace(this.cache.white, function (m) {
                            return m + parts[1] + ' ';
                        });
                        break;
                    case 4:
                        i = 0;
                        if (parts[0] !== parts[1] || parts[2] !== parts[3]) {
                            value = value.replace(this.cache.match, function () {
                                return parts[(5 - i++) % 4];
                            });
                        }
                        break;
                }
            }
            return value;
        },
        action: function (prop, value) {
            if (this.cache === null) {
                this.cache = {
                    match: /[^\s\uFFFD]+/g,
                    slash: /[^\/]+/g,
                    white: /(^\s*)/,
                };
            }
            var state = index_1.default.guardFunctions(value);
            state.value = state.value.replace(this.cache.slash, function (m) {
                return this.flip(m);
            }.bind(this));
            return { prop: prop, value: index_1.default.unguardFunctions(state) };
        },
    },
    {
        name: 'shadow',
        expr: /shadow/gi,
        cache: null,
        action: function (prop, value) {
            if (this.cache === null) {
                this.cache = {
                    replace: /[^,]+/g,
                };
            }
            var colorSafe = index_1.default.guardHexColors(value);
            var funcSafe = index_1.default.guardFunctions(colorSafe.value);
            funcSafe.value = funcSafe.value.replace(this.cache.replace, function (m) {
                return index_1.default.negate(m);
            });
            colorSafe.value = index_1.default.unguardFunctions(funcSafe);
            return { prop: prop, value: index_1.default.unguardHexColors(colorSafe) };
        },
    },
    {
        name: 'transform and perspective origin',
        expr: /(?:transform|perspective)-origin/gi,
        cache: null,
        flip: function (value) {
            if (value === '0') {
                value = '100%';
            }
            else if (value.match(this.cache.percent)) {
                value = index_1.default.complement(value);
            }
            else if (value.match(this.cache.length)) {
                value = index_1.default.flipLength(value);
            }
            return value;
        },
        action: function (prop, value) {
            if (this.cache === null) {
                this.cache = {
                    match: index_1.default.regex(['calc', 'percent', 'length'], 'g'),
                    percent: index_1.default.regex(['calc', 'percent'], 'i'),
                    length: index_1.default.regex(['length'], 'gi'),
                    xKeyword: /(left|right)/i,
                };
            }
            if (value.match(this.cache.xKeyword)) {
                value = index_1.default.swapLeftRight(value);
            }
            else {
                var state = index_1.default.guardFunctions(value);
                var parts_1 = state.value.match(this.cache.match);
                if (parts_1 && parts_1.length > 0) {
                    parts_1[0] = this.flip(parts_1[0]);
                    state.value = state.value.replace(this.cache.match, function () {
                        return parts_1.shift();
                    });
                    value = index_1.default.unguardFunctions(state);
                }
            }
            return { prop: prop, value: value };
        },
    },
    {
        name: 'transform',
        expr: /^(?!text\-).*?transform$/gi,
        cache: null,
        flip: function (value, process) {
            var i = 0;
            return value.replace(this.cache.unit, function (num) {
                return process(++i, num);
            });
        },
        flipMatrix: function (value) {
            return this.flip(value, function (i, num) {
                if (i === 2 || i === 3 || i === 5) {
                    return index_1.default.negate(num);
                }
                return num;
            });
        },
        flipMatrix3D: function (value) {
            return this.flip(value, function (i, num) {
                if (i === 2 || i === 4 || i === 5 || i === 13) {
                    return index_1.default.negate(num);
                }
                return num;
            });
        },
        flipRotate3D: function (value) {
            return this.flip(value, function (i, num) {
                if (i === 1 || i === 4) {
                    return index_1.default.negate(num);
                }
                return num;
            });
        },
        action: function (prop, value) {
            if (this.cache === null) {
                this.cache = {
                    negatable: /((translate)(x|3d)?|rotate(z|y)?)$/gi,
                    unit: index_1.default.regex(['calc', 'number'], 'g'),
                    matrix: /matrix$/i,
                    matrix3D: /matrix3d$/i,
                    skewXY: /skew(x|y)?$/i,
                    rotate3D: /rotate3d$/i,
                };
            }
            var state = index_1.default.guardFunctions(value);
            return {
                prop: prop,
                value: index_1.default.unguardFunctions(state, function (v, n) {
                    if (n.length) {
                        if (n.match(this.cache.matrix3D)) {
                            v = this.flipMatrix3D(v);
                        }
                        else if (n.match(this.cache.matrix)) {
                            v = this.flipMatrix(v);
                        }
                        else if (n.match(this.cache.rotate3D)) {
                            v = this.flipRotate3D(v);
                        }
                        else if (n.match(this.cache.skewXY)) {
                            v = index_1.default.negateAll(v);
                        }
                        else if (n.match(this.cache.negatable)) {
                            v = index_1.default.negate(v);
                        }
                    }
                    return v;
                }.bind(this)),
            };
        },
    },
    {
        name: 'transition',
        expr: /transition(-property)?$/i,
        action: function (prop, value) {
            return { prop: prop, value: index_1.default.swapLeftRight(value) };
        },
    },
    {
        name: 'background',
        expr: /background(-position(-x)?|-image)?$/i,
        cache: null,
        flip: function (value) {
            var state = index_1.default.saveTokens(value, true);
            var parts = state.value.match(this.cache.match);
            if (parts && parts.length > 0) {
                var keywords = (state.value.match(this.cache.position) || '').length;
                if (parts.length >= 3 ||
                    keywords === 2) {
                    state.value = index_1.default.swapLeftRight(state.value);
                }
                else {
                    parts[0] =
                        parts[0] === '0'
                            ? '100%'
                            : parts[0].match(this.cache.percent)
                                ? index_1.default.complement(parts[0])
                                : parts[0].match(this.cache.length)
                                    ? index_1.default.flipLength(parts[0])
                                    : index_1.default.swapLeftRight(parts[0]);
                    state.value = state.value.replace(this.cache.match, function () {
                        return parts.shift();
                    });
                }
            }
            return index_1.default.restoreTokens(state);
        },
        update: function (context, value, name) {
            if (name.match(this.cache.gradient)) {
                value = index_1.default.swapLeftRight(value);
                if (value.match(this.cache.angle)) {
                    value = index_1.default.negate(value);
                }
            }
            else if (context.config.processUrls === true ||
                (context.config.processUrls.decl === true && name.match(this.cache.url))) {
                value = index_1.default.applyStringMap(value, true);
            }
            return value;
        },
        action: function (prop, value) {
            if (this.cache === null) {
                this.cache = {
                    match: index_1.default.regex(['position', 'percent', 'length', 'calc'], 'ig'),
                    percent: index_1.default.regex(['calc', 'percent'], 'i'),
                    position: index_1.default.regex(['position'], 'g'),
                    length: index_1.default.regex(['length'], 'gi'),
                    gradient: /gradient$/i,
                    angle: /\d+(deg|g?rad|turn)/i,
                    url: /^url/i,
                };
            }
            var colorSafe = index_1.default.guardHexColors(value);
            var funcSafe = index_1.default.guardFunctions(colorSafe.value);
            var parts = funcSafe.value.split(',');
            var lprop = prop.toLowerCase();
            if (lprop !== 'background-image') {
                for (var x = 0; x < parts.length; x++) {
                    parts[x] = this.flip(parts[x]);
                }
            }
            funcSafe.value = parts.join(',');
            colorSafe.value = index_1.default.unguardFunctions(funcSafe, this.update.bind(this, { config: index_1.config }));
            return {
                prop: prop,
                value: index_1.default.unguardHexColors(colorSafe),
            };
        },
    },
    {
        name: 'keyword',
        expr: /float|clear|text-align|textAlign/i,
        action: function (prop, value) {
            return { prop: prop, value: index_1.default.swapLeftRight(value) };
        },
    },
    {
        name: 'cursor',
        expr: /cursor/i,
        cache: null,
        update: function (context, value, name) {
            if (context.config.processUrls === true ||
                (context.config.processUrls.decl === true && name.match(this.cache.url))) {
                value = index_1.default.applyStringMap(value, true);
            }
            return value;
        },
        flip: function (value) {
            return value.replace(this.cache.replace, function (s, m) {
                return s.replace(m, m
                    .replace(this.cache.e, '*')
                    .replace(this.cache.w, 'e')
                    .replace(this.cache.star, 'w'));
            }.bind(this));
        },
        action: function (prop, value) {
            if (this.cache === null) {
                this.cache = {
                    replace: /\b(ne|nw|se|sw|nesw|nwse)-resize/gi,
                    url: /^url/i,
                    e: /e/i,
                    w: /w/i,
                    star: /\*/i,
                };
            }
            var state = index_1.default.guardFunctions(value);
            var parts = state.value.split(',');
            for (var x = 0; x < parts.length; x++) {
                parts[x] = this.flip(parts[x]);
            }
            state.value = parts.join(',');
            return {
                prop: prop,
                value: index_1.default.unguardFunctions(state, this.update.bind(this, { config: index_1.config })),
            };
        },
    },
];
exports.process = function (cssProp, cssValue) {
    var result;
    var defaultResult = { prop: cssProp, value: cssValue };
    if (cssValue === undefined || cssValue === null)
        return defaultResult;
    for (var _i = 0, processorList_1 = exports.processorList; _i < processorList_1.length; _i++) {
        var processor = processorList_1[_i];
        if (cssProp.match(processor.expr)) {
            result = processor.action(cssProp, cssValue);
            break;
        }
    }
    return result || defaultResult;
};
exports.scaleCss = 'scaleX( -1)';


/***/ }),

/***/ "./src/utilities/index.ts":
/*!********************************!*\
  !*** ./src/utilities/index.ts ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isObject = exports.isDisabledClassName = exports.addDisabledClassName = exports.disabledClassNames = exports.isBlank = exports.isIgnoreComponent = exports.initRuntimeOption = exports.addDisabledComponents = exports.stashReact = exports.disabledComponents = exports.normalizeStyleBinding = exports.toObject = exports.extend = exports.setSkipStatus = exports.skipCSSProcess = exports.setRTLStatus = exports.isRTL = exports.config = void 0;
exports.config = {
    autoRename: false,
    autoRenameStrict: false,
    clean: true,
    greedy: false,
    processUrls: false,
    stringMap: [],
    useCalc: false,
};
var CHAR_COMMENT_REPLACEMENT = '\uFFFD';
var CHAR_TOKEN_REPLACEMENT = '\u00A4';
var CHAR_TOKEN_START = '\u00AB';
var CHAR_TOKEN_END = '\u00BB';
var REGEX_COMMENT_REPLACEMENT = new RegExp(CHAR_COMMENT_REPLACEMENT, 'ig');
var REGEX_TOKEN_REPLACEMENT = new RegExp(CHAR_TOKEN_REPLACEMENT, 'ig');
var PATTERN_NUMBER = '\\-?(\\d*?\\.\\d+|\\d+)';
var PATTERN_NUMBER_WITH_CALC = '(calc' + CHAR_TOKEN_REPLACEMENT + ')|(' + PATTERN_NUMBER + ')(?!d\\()';
var PATTERN_TOKEN = CHAR_TOKEN_START + '\\d+:\\d+' + CHAR_TOKEN_END;
var PATTERN_TOKEN_WITH_NAME = '\\w*?' + CHAR_TOKEN_START + '\\d+:\\d+' + CHAR_TOKEN_END;
var REGEX_COMMENT = /\/\*[^]*?\*\//gim;
var REGEX_DIRECTIVE = /\/\*\s*(?:!)?\s*rtl:[^]*?\*\//gim;
var REGEX_ESCAPE = /[.*+?^${}()|[\]\\]/g;
var REGEX_FUNCTION = /\([^\(\)]+\)/i;
var REGEX_HEX_COLOR = /#[a-f0-9]{3,6}/gi;
var REGEX_CALC = /calc/;
var REGEX_TOKENS = new RegExp(PATTERN_TOKEN, 'ig');
var REGEX_TOKENS_WITH_NAME = new RegExp(PATTERN_TOKEN_WITH_NAME, 'ig');
var REGEX_COMPLEMENT = new RegExp(PATTERN_NUMBER_WITH_CALC, 'i');
var REGEX_NEGATE_ALL = new RegExp(PATTERN_NUMBER_WITH_CALC, 'ig');
var REGEX_NEGATE_ONE = new RegExp(PATTERN_NUMBER_WITH_CALC, 'i');
var DEFAULT_STRING_MAP_OPTIONS = { scope: '*', ignoreCase: true };
var TOKEN_ID = 0;
function compare(what, to, ignoreCase) {
    if (ignoreCase) {
        return what.toLowerCase() === to.toLowerCase();
    }
    return what === to;
}
function escapeRegExp(string) {
    return string.replace(REGEX_ESCAPE, '\\$&');
}
var utilsStore = {
    extend: function (dest, src) {
        if (typeof dest === 'undefined' || typeof dest !== 'object') {
            dest = {};
        }
        for (var prop in src) {
            if (!dest.hasOwnProperty(prop)) {
                dest[prop] = src[prop];
            }
        }
        return dest;
    },
    swap: function (value, a, b, options) {
        var expr = escapeRegExp(a) + '|' + escapeRegExp(b);
        options = options || DEFAULT_STRING_MAP_OPTIONS;
        var greedy = options.hasOwnProperty('greedy')
            ? options.greedy
            : exports.config.greedy;
        if (!greedy) {
            expr = '\\b(' + expr + ')\\b';
        }
        var flags = options.ignoreCase ? 'img' : 'mg';
        return value.replace(new RegExp(expr, flags), function (m) {
            return compare(m, a, options.ignoreCase) ? b : a;
        });
    },
    swapLeftRight: function (value) {
        return this.swap(value, 'left', 'right');
    },
    swapLtrRtl: function (value) {
        return this.swap(value, 'ltr', 'rtl');
    },
    applyStringMap: function (value, isUrl) {
        var result = value;
        for (var x = 0; x < exports.config.stringMap.length; x++) {
            var map = exports.config.stringMap[x];
            var options = this.extend(map.options, DEFAULT_STRING_MAP_OPTIONS);
            if (options.scope === '*' ||
                (isUrl && options.scope === 'url') ||
                (!isUrl && options.scope === 'selector')) {
                if (Array.isArray(map.search) && Array.isArray(map.replace)) {
                    for (var mapIndex = 0; mapIndex < map.search.length; mapIndex++) {
                        result = this.swap(result, map.search[mapIndex], map.replace[mapIndex % map.search.length], options);
                    }
                }
                else {
                    result = this.swap(result, map.search, map.replace, options);
                }
                if (map.exclusive === true) {
                    break;
                }
            }
        }
        return result;
    },
    negate: function (value) {
        var state = this.saveTokens(value);
        state.value = state.value.replace(REGEX_NEGATE_ONE, function (num) {
            return REGEX_TOKEN_REPLACEMENT.test(num)
                ? num.replace(REGEX_TOKEN_REPLACEMENT, function (m) {
                    return '(-1*' + m + ')';
                })
                : parseFloat(num) * -1;
        });
        return this.restoreTokens(state);
    },
    negateAll: function (value) {
        var state = this.saveTokens(value);
        state.value = state.value.replace(REGEX_NEGATE_ALL, function (num) {
            return REGEX_TOKEN_REPLACEMENT.test(num)
                ? num.replace(REGEX_TOKEN_REPLACEMENT, function (m) {
                    return '(-1*' + m + ')';
                })
                : parseFloat(num) * -1;
        });
        return this.restoreTokens(state);
    },
    complement: function (value) {
        var state = this.saveTokens(value);
        state.value = state.value.replace(REGEX_COMPLEMENT, function (num) {
            return REGEX_TOKEN_REPLACEMENT.test(num)
                ? num.replace(REGEX_TOKEN_REPLACEMENT, function (m) {
                    return '(100% - ' + m + ')';
                })
                : 100 - parseFloat(num);
        });
        return this.restoreTokens(state);
    },
    flipLength: function (value) {
        return exports.config.useCalc ? 'calc(100% - ' + value + ')' : value;
    },
    save: function (what, who, replacement, restorer, exclude) {
        var state = {
            value: who,
            store: [],
            replacement: replacement,
            restorer: restorer,
        };
        state.value = state.value.replace(what, function (c) {
            if (exclude && c.match(exclude)) {
                return c;
            }
            else {
                state.store.push(c);
                return state.replacement;
            }
        });
        return state;
    },
    restore: function (state) {
        var index = 0;
        var result = state.value.replace(state.restorer, function () {
            return state.store[index++];
        });
        state.store.length = 0;
        return result;
    },
    saveComments: function (value) {
        return this.save(REGEX_COMMENT, value, CHAR_COMMENT_REPLACEMENT, REGEX_COMMENT_REPLACEMENT);
    },
    restoreComments: function (state) {
        return this.restore(state);
    },
    saveTokens: function (value, excludeCalc) {
        return excludeCalc === true
            ? this.save(REGEX_TOKENS_WITH_NAME, value, CHAR_TOKEN_REPLACEMENT, REGEX_TOKEN_REPLACEMENT, REGEX_CALC)
            : this.save(REGEX_TOKENS, value, CHAR_TOKEN_REPLACEMENT, REGEX_TOKEN_REPLACEMENT);
    },
    restoreTokens: function (state) {
        return this.restore(state);
    },
    guard: function (what, who, indexed) {
        var state = {
            value: who,
            store: [],
            offset: TOKEN_ID++,
            token: CHAR_TOKEN_START + TOKEN_ID,
            indexed: indexed === true,
        };
        if (state.indexed === true) {
            while (what.test(state.value)) {
                state.value = state.value.replace(what, function (m) {
                    state.store.push(m);
                    return state.token + ':' + state.store.length + CHAR_TOKEN_END;
                });
            }
        }
        else {
            state.value = state.value.replace(what, function (m) {
                state.store.push(m);
                return state.token + CHAR_TOKEN_END;
            });
        }
        return state;
    },
    unguard: function (state, callback) {
        if (state.indexed === true) {
            var detokenizer = new RegExp('(\\w*?)' + state.token + ':(\\d+)' + CHAR_TOKEN_END, 'i');
            while (detokenizer.test(state.value)) {
                state.value = state.value.replace(detokenizer, function (match, name, index) {
                    var value = state.store[index - 1];
                    if (typeof callback === 'function') {
                        return name + callback(value, name);
                    }
                    return name + value;
                });
            }
            return state.value;
        }
        else {
            return state.value.replace(new RegExp('(\\w*?)' + state.token + CHAR_TOKEN_END, 'i'), function (match, name) {
                var value = state.store.shift();
                if (typeof callback === 'function') {
                    return name + callback(value, name);
                }
                return name + value;
            });
        }
    },
    guardHexColors: function (value) {
        return this.guard(REGEX_HEX_COLOR, value, true);
    },
    unguardHexColors: function (state, callback) {
        return this.unguard(state, callback);
    },
    guardFunctions: function (value) {
        return this.guard(REGEX_FUNCTION, value, true);
    },
    unguardFunctions: function (state, callback) {
        return this.unguard(state, callback);
    },
    trimDirective: function (value) {
        return value.replace(REGEX_DIRECTIVE, '');
    },
    regexCache: {},
    regexDirective: function (name) {
        this.regexCache[name] =
            this.regexCache[name] ||
                new RegExp('(?:\\/\\*\\s*(?:!)?\\s*rtl:' +
                    (name ? escapeRegExp(name) + '(?::)?' : '') +
                    ')([^]*?)(?:\\*\\/)', 'img');
        return this.regexCache[name];
    },
    regex: function (what, options) {
        what = what || [];
        var expression = '';
        for (var x = 0; x < what.length; x++) {
            switch (what[x]) {
                case 'percent':
                    expression += '|(' + PATTERN_NUMBER + '%)';
                    break;
                case 'length':
                    expression +=
                        '|(' +
                            PATTERN_NUMBER +
                            ')(?:ex|ch|r?em|vh|vw|vmin|vmax|px|mm|cm|in|pt|pc)?';
                    break;
                case 'number':
                    expression += '|(' + PATTERN_NUMBER + ')';
                    break;
                case 'position':
                    expression += '|(left|center|right|top|bottom)';
                    break;
                case 'calc':
                    expression += '|(calc' + PATTERN_TOKEN + ')';
                    break;
            }
        }
        return new RegExp(expression.slice(1), options);
    },
    isLastOfType: function (node) {
        var isLast = true;
        var next = node.next();
        while (next) {
            if (next && next.type === node.type) {
                isLast = false;
                break;
            }
            next = next.next();
        }
        return isLast;
    },
    each: function (array, callback) {
        for (var len = 0; len < array.length; len++) {
            if (callback(array[len]) === false) {
                return false;
            }
        }
        return true;
    },
};
exports.setRTLStatus = function (is) {
    exports.isRTL = is;
};
exports.setSkipStatus = function (is) {
    exports.skipCSSProcess = is;
};
exports.extend = function extend(to, _from) {
    for (var key in _from) {
        to[key] = _from[key];
    }
    return to;
};
exports.toObject = function toObject(arr) {
    var res = {};
    for (var i = 0; i < arr.length; i++) {
        if (arr[i]) {
            exports.extend(res, arr[i]);
        }
    }
    return res;
};
exports.normalizeStyleBinding = function (bindingStyle) {
    if (Array.isArray(bindingStyle)) {
        return exports.toObject(bindingStyle);
    }
    if (typeof bindingStyle === 'string') {
        return parseStyleText(bindingStyle);
    }
    return bindingStyle;
};
exports.disabledComponents = [];
exports.addDisabledComponents = function (components) {
    exports.disabledComponents = __spreadArrays(exports.disabledComponents, components);
};
var resetDisabledComponents = function () {
    exports.disabledComponents = [];
};
exports.initRuntimeOption = function (option, react) {
    if (!option)
        return;
    exports.stashReact = react;
    if (option.disabledComponent) {
        resetDisabledComponents();
        exports.addDisabledComponents(option.disabledComponent);
    }
};
exports.isIgnoreComponent = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (!exports.disabledComponents.length)
        return;
    var current = (_b = (_a = exports.stashReact === null || exports.stashReact === void 0 ? void 0 : exports.stashReact.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _a === void 0 ? void 0 : _a.ReactCurrentOwner) === null || _b === void 0 ? void 0 : _b.current;
    if (!current)
        return;
    var name = (_c = current === null || current === void 0 ? void 0 : current.elementType) === null || _c === void 0 ? void 0 : _c.name;
    if (!name)
        return;
    if (exports.disabledComponents.includes(name))
        return true;
    var parentName = ((_e = (_d = current === null || current === void 0 ? void 0 : current._debugOwner) === null || _d === void 0 ? void 0 : _d.elementType) === null || _e === void 0 ? void 0 : _e.name) || ((_h = (_g = (_f = current === null || current === void 0 ? void 0 : current._debugOwner) === null || _f === void 0 ? void 0 : _f.elementType) === null || _g === void 0 ? void 0 : _g.render) === null || _h === void 0 ? void 0 : _h.displayName);
    if (!parentName)
        return;
    if (exports.disabledComponents.includes(parentName) && !exports.disabledComponents.includes(name)) {
        exports.addDisabledComponents([name]);
        return true;
    }
};
exports.isBlank = function (value) {
    return value === undefined || value === null;
};
exports.disabledClassNames = [];
exports.addDisabledClassName = function (className) {
    exports.disabledClassNames.push.apply(exports.disabledClassNames, className.split(' '));
};
exports.isDisabledClassName = function (className) {
    return exports.disabledClassNames.length && className.split(' ').some(function (item) { return exports.disabledClassNames.includes(item); });
};
var parseStyleText = function (cssText) {
    var res = {};
    var listDelimiter = /;(?![^(]*\))/g;
    var propertyDelimiter = /:(.+)/;
    cssText.split(listDelimiter).forEach(function (item) {
        if (item) {
            var tmp = item.split(propertyDelimiter);
            tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return res;
};
exports.isObject = function (data) {
    return Object.prototype.toString.call(data) === '[object Object]';
};
exports.default = utilsStore;


/***/ }),

/***/ "react":
/*!************************!*\
  !*** external "react" ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ })

/******/ })));